// @flow
import { styled } from 'mz-ui-kit'
import { getAppearanceFunc } from '../../../utils'
import * as desktopAppearance from './appearance/desktop'
import * as mobileAppearance from './appearance/mobile'

// Constants
const APPEARANCES = {
  desktop: desktopAppearance,
  mobile: mobileAppearance,
}

const createAppearanceFunc = getAppearanceFunc(APPEARANCES, 'desktop')

export const Container = styled('div', createAppearanceFunc('Container'))
export const Content = styled('div', createAppearanceFunc('Content'))
export const ButtonContainer = styled(
  'div',
  createAppearanceFunc('ButtonContainer')
)
